import { type JSX, type MouseEvent, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import { type ButtonProps } from "@mui/material/Button/Button";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

type Props = {
  title: string;
  buttonProps?: Omit<ButtonProps, "onClick">;
  children: JSX.Element;
};

export const ConfirmMenu = ({ title, buttonProps, children }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // there is an issue with rendering the drag and drop children directly when the menu is opened,
  // there should be a delay after the menu is clicked, so do not remove this state!
  const [renderChildren, setRenderChildren] = useState<boolean>(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);

    // do not remove this timeout
    setTimeout(() => {
      setRenderChildren(true);
    }, 0);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setRenderChildren(false);
  };

  return (
    <>
      <IconButton
        {...buttonProps}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: "primary.main",
        }}
      >
        <EditIcon />
      </IconButton>
      {open && (
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          <Stack spacing={1}>
            <Typography
              variant="h4"
              sx={{
                pl: 2,
                pt: 1,
              }}
            >
              {title}
            </Typography>
            <Divider />
            {renderChildren && children}
          </Stack>
        </Menu>
      )}
    </>
  );
};
